import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";

import Moderate from "../../../../assets/images/Sharjah/Onboarding/9.png";
import Conservative from "../../../../assets/images/Sharjah/Onboarding/10.png";
import Aggressive from "../../../../assets/images/Sharjah/Onboarding/11.png";

// import Moderate from '../../../../assets/images/Sharjah/Onboarding/3.png';
// import Conservative from '../../../../assets/images/Sharjah/Onboarding/1.png';
// import Aggressive from '../../../../assets/images/Sharjah/Onboarding/2.png';

import { useTranslation } from "react-i18next";
import * as Helpers from "../../../../global/Helpers";
import i18next from "i18next";

const FatcaCRSDeclaration4 = (props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("2");
  const [srcImg, setSrcImg] = useState(Moderate);

  const handleClick = (value) => {
    setSelected(value);
    if (value == "2") setSrcImg(Moderate);
    else if (value == "3") setSrcImg(Aggressive);
    else if (value == "1") setSrcImg(Conservative);
  };

  const [OneSwitch, setOneSwitch] = useState(false);
  const [ZeroSwitch, setZeroSwitch] = useState(false);
  const handleSwitchChangeOne = (event) => {
    setOneSwitch(event.target.checked);
  };
  const handleSwitchChangeZero = (event) => {
    setZeroSwitch(event.target.checked);
  };
  const [TwoSwitch, setTwoSwitch] = useState(false);
  const handleSwitchChangeTwo = (event) => {
    setTwoSwitch(event.target.checked);
  };

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (selected === "") {
      Helpers.errorNotify(t("Please fill Risk Appetite"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }

    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;

    var result = Helpers.getScreenIdByGroupAndName("Risk Appetite");

    var Items = [
      { ID: "226", Value: selected },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    props.saveKycDataAPI(Items);
  };

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="form-group">
            <h5>{t("RiskAppetite")}</h5>
            <div className="seekbar-wrapper RiskAppetite">
              <h6>{t("risk_appetite_message")}</h6>
              {/* <h6>Changing this selection will not affect your application.</h6> */}

              <div
                className="InvestmentFrequency-container"
                style={{ marginBottom: "2rem" }}
              >
                <img src={srcImg} style={{ height: "240px" }} />

                <div className="button-group">
                  <button
                    className={`frequency-button ${
                      selected === "1" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick("1");
                    }}
                  >
                    {t("Conservative")}
                  </button>
                  <button
                    className={`frequency-button ${
                      selected === "2" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick("2");
                    }}
                  >
                    {t("Moderate")}
                  </button>
                  <button
                    className={`frequency-button ${
                      selected === "3" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick("3");
                    }}
                  >
                    {t("Aggressive")}
                  </button>
                </div>
              </div>

              {/* <div
                className="form-group"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label htmlFor="dropdown5" className="form-label">
                  {t("tolerate_risk_for_returns")}
                </label>
              </div> */}

              <div
                className="form-group"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label htmlFor="dropdown5" className="form-label">
                  {t("tolerate_risk_for_returns")}
                </label>
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={ZeroSwitch}
                      onChange={handleSwitchChangeZero}
                    />
                    <span className="slider"></span>
                  </label>
                  {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
                </div>
              </div>
              <div
                className="form-group"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label htmlFor="dropdown5" className="form-label">
                  {t("arrange_credit_investment_deals")}
                </label>
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={OneSwitch}
                      onChange={handleSwitchChangeOne}
                    />
                    <span className="slider"></span>
                  </label>
                  {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
                </div>
              </div>
              <div
                className="form-group"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <label htmlFor="dropdown5" className="form-label">
                  {t("licensed_by_securities_authority")}
                </label>
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={TwoSwitch}
                      onChange={handleSwitchChangeTwo}
                    />
                    <span className="slider"></span>
                  </label>
                  {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
                </div>
              </div>
            </div>
          </div>

          {/* <button type="submit" className="submit-button">Submit</button> */}
        </form>
      </div>
    </div>
  );
};

export default FatcaCRSDeclaration4;
